import { onDocumentReady } from '../utils/events';
import Splide from '@splidejs/splide';
import { AdjustableHeight } from '../utils/splide-auto-height';

onDocumentReady(() => {
  const sliderEl = document.querySelector('.testimonials__items');

  if (sliderEl) {
    const splide = new Splide(sliderEl, {
      type: 'loop',
      perMove: 1,
      perPage: 2,
      gap: '2.875rem',
      drag: true,
      flickPower: 150,
      dragMinThreshold: {
        mouse: 40,
        touch: 70,
      },
      arrows: true,
      pagination: true,
      keyboard: 'focused',
      rewind: true,
      focus: 0,
      breakpoints: {
        1200: {
          gap: '1.875rem',
        },
        1024: {
          perPage: 1,
        },
        640: {
          pagination: false,
        },
      },
    });
    splide.mount({ AdjustableHeight });
  }
});
